import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from 'common/constants';

export const fetchEmployees = createAsyncThunk('employees/fetch', async () => {
  const response = await axios(`${BASE_URL}/employees`);
  return response.data;
});
